import { formatarCNPJ } from "../../../utils";
import { ListDescriptions } from "../../../components/ListDescriptions";
import { Panel } from "primereact/panel";
 
type InscricaoEstadual = {
  situacao: string;
  vinculo: string;
  inscricao: string;
  ativoHabilitada: string;
};
 
type DadosEmpresa = {
  uf: string;
  ie: string;
  cep: string;
  cnpj: string;
  numero: number;
  bairro: string;
  municipio: string;
  cpf: string | null;
  logradouro: string;
  complemento: string;
  nomeFantasia: string;
  email: string | null;
  dataConsulta: string;
  regimeApuracao: string;
  nomeEmpresarial: string;
  telefone: string | null;
  observacao: string | null;
  situacaoCadastral: string;
  dataAbertura: string | null;
  dataInicioAtividade: string;
  informacaoIBGE: string | null;
  dataSituacaoCadastral: string;
  codigoControle: string | null;
  ocorrenciaFiscal: string | null;
  dataFimAtividade: string | null;
  naturezaJuridica: string | null;
  atividadeEconomicaPrincipal: string;
  motivoSituacaoCadastral: string | null;
  inscricoesEstaduais: InscricaoEstadual[];
  atividadesEconomicasSecundarias: string[];
  situacaoContribuinteNaData: string | null;
  indicadorObrigatoriedadeNFe: string | null;
  dataCredenciamentoEmissorNFe: string | null;
  dataInicioObrigatoriedadeNFe: string | null;
  MENSAGEM: string | null;
};
 
export type DadosProps = {
  label: string;
  value: string | null;
};
 
type CategoriaDados = {
  categoria: string;
  dados: DadosProps[];
};
 
function formatarDadosEmpresa(dados: DadosEmpresa): CategoriaDados[] {
  return [
    {
      categoria: "Informações da Empresa",
      dados: [
        { label: "CNPJ", value: formatarCNPJ(dados.cnpj) },
        { label: "Razão Social", value: dados.nomeEmpresarial },
        { label: "Nome Fantasia", value: dados.nomeFantasia },
        { label: "Telefone", value: dados.telefone },
        { label: "E-mail", value: dados.email },
      ],
    },
    {
      categoria: "Endereço da Empresa",
      dados: [
        { label: "Logradouro", value: dados.logradouro },
        { label: "Número", value: dados.numero.toString() },
        { label: "Complemento", value: dados.complemento },
        { label: "Bairro", value: dados.bairro },
        { label: "CEP", value: dados.cep },
        { label: "Município", value: dados.municipio },
        { label: "UF", value: dados.uf },
      ],
    },
    {
      categoria: "Atividades Econômicas",
      dados: [
        {
          label: "Atividade Econômica Principal",
          value: dados.atividadeEconomicaPrincipal,
        },
        {
          label: "Atividades Econômicas Secundárias",
          value:
            dados.atividadesEconomicasSecundarias.length > 0
              ? dados.atividadesEconomicasSecundarias.join(", ")
              : null,
        },
      ],
    },
    {
      categoria: "Informações Cadastrais",
      dados: [
        { label: "Natureza Jurídica", value: dados.naturezaJuridica },
        { label: "Situação Cadastral", value: dados.situacaoCadastral },
        {
          label: "Motivo Situação Cadastral",
          value: dados.motivoSituacaoCadastral,
        },
        {
          label: "Início Atividade com ICMS",
          value: dados.dataInicioAtividade,
        },
        {
          label: "Data Situação Cadastral",
          value: dados.dataSituacaoCadastral,
        },
      ],
    },
    {
      categoria: "Informações de Obrigações Fiscais",
      dados: [
        { label: "Regime Apuração", value: dados.regimeApuracao },
        {
          label: "Data Credenciamento Emissor NFE",
          value: dados.dataCredenciamentoEmissorNFe,
        },
        {
          label: "Data Início Obrigatoriedade NFE",
          value: dados.dataInicioObrigatoriedadeNFe,
        },
        {
          label: "Situação do Contribuinte na Data",
          value: dados.situacaoContribuinteNaData,
        },
        { label: "Informação IBGE", value: dados.informacaoIBGE },
        { label: "Ocorrência Fiscal", value: dados.ocorrenciaFiscal },
        { label: "Código de Controle", value: dados.codigoControle },
        { label: "Data de Abertura", value: dados.dataAbertura },
        { label: "Data Fim Atividade", value: dados.dataFimAtividade },
      ],
    },
    {
      categoria: "Informações de Inscrição Estadual",
      dados: dados.inscricoesEstaduais.flatMap((inscricao) => [
        { label: "Inscrição", value: inscricao.inscricao },
        { label: "Situação", value: inscricao.situacao },
        { label: "Vínculo", value: inscricao.vinculo },
        { label: "Ativo/Habilitada", value: inscricao.ativoHabilitada },
      ]),
    },
  ];
}
 
export function Sintegra({ data }: { data: DadosEmpresa }) {
  return (
    <Panel header="Sintegra">
      {data.MENSAGEM ? (<p>{data.MENSAGEM}</p>) : (<>
      {formatarDadosEmpresa(data).map(({ dados, categoria }) => (
        <ListDescriptions dados={dados} key={categoria} categoria={categoria} />
      ))}
    </>)}
    </Panel>
  );
}